
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.236 3.673h-.027a.433.433 0 00-.3.154.416.416 0 00-.111.313.425.425 0 00.153.3 3.467 3.467 0 011.192 2.628 3.529 3.529 0 01-1.189 2.625.442.442 0 00-.048.613.413.413 0 00.323.148.38.38 0 00.287-.114 4.417 4.417 0 001.488-3.272 4.373 4.373 0 00-1.48-3.285.41.41 0 00-.288-.11zM1.423 3.645A1.425 1.425 0 000 5.068v3.986a1.425 1.425 0 001.423 1.423H3.86l.034.02 5.459 3.2a.788.788 0 00.416.117.735.735 0 00.412-.115.822.822 0 00.421-.718V1.12a.787.787 0 00-.4-.715.826.826 0 00-.83 0L3.857 3.647zm8.319 9.244L4.436 9.768V4.314l5.306-3.121zM3.536 9.596H1.423a.565.565 0 01-.542-.561V5.068a.543.543 0 01.542-.542h2.113z"}})])
          )
        }
      }
    